import { Swiper, Parallax, Navigation, Pagination } from 'swiper';

Swiper.use([ Parallax, Navigation, Pagination ]);

export function initializeNewsCarousel() {
    document.addEventListener('DOMContentLoaded', function() {
        new Swiper(".new-news-carousel", {
            slidesPerView: 'auto',
            spaceBetween: 16,
            breakpoints: {
                320: {
                    spaceBetween: 8,
                },
                1920: {
                    centeredSlides: false,
                },
            },
            navigation: {
                nextEl: ".new-news-carousel__button_next",
                prevEl: ".new-news-carousel__button_prev",
            },
        });
    });
}
